// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2YTbY","form":"styles_form__1rbNT"};